import * as Redux from "redux";
import { SupervisorApi } from '../apis';

import { ActionTypes } from "./actionTypes";
import {
  FETCH_PILLS_SUCCESS,
  SET_PILLS_KEYWORD,
  FETCH_SUGGESTIONS_REQUEST,
  FETCH_SUGGESTIONS_SUCCESS,
  FETCH_SUGGESTIONS_FAILURE
} from './actionTypes';

interface Action extends Redux.Action {
    type: ActionTypes;
    payload?: any;
    context?: number | string;
}

export default Action;

// DISABLED: pills service — re-enable when restoring PillsBar + GET /pills route
export const fetchPills = (_customerId?: string | null) => async (dispatch: any) => {
  dispatch({ type: FETCH_PILLS_SUCCESS, payload: [] });
  // dispatch({ type: FETCH_PILLS_REQUEST });
  // try {
  //   const response = await new SupervisorApi().getPills(customerId);
  //   dispatch({ type: FETCH_PILLS_SUCCESS, payload: response });
  // } catch (error: any) {
  //   dispatch({ type: FETCH_PILLS_FAILURE, payload: error?.message || 'Failed to fetch pills' });
  // }
};

export const fetchSuggestions = (query: string, customerId?: string, mspId?: string, ticketId?: string) => async (dispatch: any) => {
  dispatch({ type: FETCH_SUGGESTIONS_REQUEST });
  try {
    const response = await new SupervisorApi().getSuggestions(query, customerId, mspId, ticketId);
    dispatch({ type: FETCH_SUGGESTIONS_SUCCESS, payload: response });
  } catch (error: any) {
    console.error('[Frontend] API call failed:', error);
    dispatch({ type: FETCH_SUGGESTIONS_FAILURE, payload: error?.message || 'Failed to fetch suggestions' });
  }
};

export const setPillsKeyword = (keyword: string) => ({
  type: SET_PILLS_KEYWORD,
  payload: keyword,
});
